const kebab = (title) => {
  return title.toLowerCase().split(" ").join("-");
};

module.exports = { kebab };
